document.addEventListener('DOMContentLoaded', function () {
    const readMoreButtons = document.querySelectorAll('.read-more-btn');

    readMoreButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        const container = button.closest('.read-more-container');
        const preview = container.querySelector('.read-more-preview');
        const content = container.querySelector('.read-more-content');

        // Toggle visibility
        if (content.style.display === 'none' || content.style.display === '') {
          content.style.display = 'inline'; // Show hidden content
          //preview.style.display = 'none';  // Hide preview
          button.textContent = 'Read Less'; // Change button text

        } else {
          content.style.display = 'none';  // Hide content
          preview.style.display = 'inline'; // Show preview
          button.textContent = 'Read More'; // Reset button text
        }
      });
    });
    
    // Clean up search field if it contains variants.sku syntax
    function cleanupSearchFields() {
      const searchInputs = document.querySelectorAll('input[name="q"]');
      searchInputs.forEach(input => {
        const value = input.value || '';
        if (value.startsWith('variants.sku:')) {
          // Extract just the SKU part
          const actualSku = value.replace('variants.sku:', '');
          input.value = actualSku;
        }
      });
    }

    // Run cleanup on page load
    cleanupSearchFields();
    
    // SKU detection function
    function looksLikeSku(str) {
      return str.toUpperCase().includes('S0') && str.includes('-');
    }
    
    // Function to handle search based on input type
    function handleSearch(event, searchInput) {
      const searchValue = searchInput.value.trim();
      
      // Don't process if it's already in variants.sku format
      if (searchValue.startsWith('variants.sku:')) {
        return;
      }
      
      if (looksLikeSku(searchValue)) {
        // It's a SKU - use SKU-specific search
        event.preventDefault();
        event.stopPropagation();
        
        // Redirect to the SKU-specific search
        const redirectUrl = `/search?q=variants.sku:${encodeURIComponent(searchValue)}&resources[type]=product`;
        window.location.href = redirectUrl;
        return false;
      } else {
        // For all other searches (including MPNs), include all searchable fields
        event.preventDefault();
        event.stopPropagation();
        
        const redirectUrl = `/search?q=${encodeURIComponent(searchValue)}&resources[type]=product&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku,variants.barcode,tag,body`;
        window.location.href = redirectUrl;
        return false;
      }
    }
    
    // Find all search forms
    const searchForms = document.querySelectorAll('form');
    const actualSearchForms = Array.from(searchForms).filter(form => {
      const action = form.getAttribute('action') || '';
      const hasSearchInput = form.querySelector('input[name="q"]') !== null;
      return action.includes('/search') || hasSearchInput;
    });
    
    actualSearchForms.forEach(function(form) {
      const searchInput = form.querySelector('input[name="q"]');
      
      if (searchInput) {
        // Handle form submission
        form.addEventListener('submit', function(event) {
          return handleSearch(event, searchInput);
        }, true);
        
        // Handle Enter key
        searchInput.addEventListener('keydown', function(event) {
          if (event.key === 'Enter') {
            return handleSearch(event, searchInput);
          }
        });
        
        // Handle search button click
        const searchButton = form.querySelector('button[type="submit"], [data-live-search-submit]');
        if (searchButton) {
          searchButton.addEventListener('click', function(event) {
            return handleSearch(event, searchInput);
          }, true);
        }
      }
    });
    
    // Override fetch to modify predictive search requests
    const originalFetch = window.fetch;
    window.fetch = function(url, options) {
      // Check if this is a predictive search request
      if (typeof url === 'string' && (url.includes('/search/suggest') || url.includes('predictive_search_url'))) {
        try {
          // Parse the URL to modify search parameters
          const urlObj = new URL(url, window.location.origin);
          const searchQuery = urlObj.searchParams.get('q');
          
          if (searchQuery) {
            if (!searchQuery.startsWith('variants.sku:') && looksLikeSku(searchQuery)) {
              // It's a SKU - use specific SKU search
              urlObj.searchParams.set('q', `variants.sku:${searchQuery}`);
            } else {
              // For all other searches, include all searchable fields
              urlObj.searchParams.set('resources[options][fields]', 'title,product_type,variants.title,vendor,variants.sku,variants.barcode,tag,body');
            }
            url = urlObj.toString();
          }
        } catch (e) {
          console.error('Error modifying search URL:', e);
        }
      }
      
      // Call the original fetch with the potentially modified URL
      return originalFetch(url, options);
    };

    console.log('Enhanced search initialized for SKUs and general product search');

    // Function to set sidebar height based on products section
    function setSidebarHeight() {
      const sidebar = document.querySelector('.productgrid--sidebar');
      const productsWrapper = document.querySelector('.productgrid--wrapper');
      const productsItems = document.querySelector('.productgrid--items');
      
      if (sidebar && (productsWrapper || productsItems) && window.innerWidth >= 860) {
        // Use products items if available, otherwise use wrapper
        const productsSection = productsItems || productsWrapper;
        const productsHeight = productsSection.offsetHeight;
        
        // Set sidebar max-height to match products section height
        // Add some padding (50px) for better visual balance
        const sidebarMaxHeight = Math.max(productsHeight + 50, 300);
        sidebar.style.maxHeight = sidebarMaxHeight + 'px';
      }
    }

    // Set initial height (DOM is already loaded at this point)
    setSidebarHeight();
    
    // Also call after a short delay to ensure all content is rendered
    setTimeout(setSidebarHeight, 100);
    
    // Update height when window is resized
    window.addEventListener('resize', function() {
      clearTimeout(window.sidebarResizeTimeout);
      window.sidebarResizeTimeout = setTimeout(setSidebarHeight, 250);
    });

    // Update height when filters change (products grid might change height)
    document.addEventListener('click', function(e) {
      if (e.target.closest('[data-filter-item]') || 
          e.target.closest('.filter-item') ||
          e.target.closest('[data-productgrid-trigger-filters]')) {
        setTimeout(setSidebarHeight, 500); // Delay to allow filtering animation
      }
    });

    // Update height when pagination changes
    document.addEventListener('click', function(e) {
      if (e.target.closest('.pagination--inner a')) {
        setTimeout(setSidebarHeight, 1000); // Delay for page load
      }
    });
});